import { createContext, useContext } from 'react';
export const MerchantContext = createContext({
  featureToggles: {},
  instantRefundsFreeTrialEligibility: {},
  easySplitEnabled: false,
  staticSplitEnabled: false,
  ssoFlag: {},
  routerStatus: '',
  isFlowwiseActive: false,
  shopifyStoreUrl: null,
  showRouterTab: false,
  showBatchLinkUpload: false,
  isShopifyMerchant: false,
  renderChatbot: false,
  productStatus: {},
  productPrivilege: {},
  productFruitCampaigns: {},
  isMerchantImportEnabled: false,
  isTransactionCurrencyEnabled: false,
  // eslint-disable-next-line no-unused-vars
  setMerchantContextData: data => {},
  resetFeatureToggles: () => {},
  selectedTimeZone: 'IST',
  setSelectedTimeZone: () => {},
});

export const MERCHANT_TYPE = {
  PG: 'PG',
  OCC: 'OCC',
  OCC_CUSTOM: 'OCC_CUSTOM',
};
export const useMerchantType = () => {
  const { productStatus: merchantProductStatus, isShopifyMerchant } =
    useContext(MerchantContext);

  if (merchantProductStatus?.ECOM360 !== 'APPROVED') return MERCHANT_TYPE.PG;

  return isShopifyMerchant ? MERCHANT_TYPE.OCC : MERCHANT_TYPE.OCC_CUSTOM;
};
